import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { OrderLogResponse } from '@models/order/orderLog';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface Props {
    orderLog: OrderLogResponse;
}

function OrderInfo({ orderLog }:Props) {
    const { t } = useTranslation('orderLog');
    const {
        createdAt, shopName, shopOrderNo, displayOrderNo, orderType, status,
    } = orderLog;
    return <Column fullWidth as='section'
        align='center'
        className={styles.container}
        spacing={16} >
        <Column align='center' spacing={4}>
            <Badge type={orderType === 'TAKE_OUT' ? 'primary' : 'secondary'}>
                {orderType === 'TAKE_OUT' ? t('info.pickup') : t('info.dineIn')}
            </Badge>
            <Text size='lg' fontWeight='bold'>
                {shopName}
            </Text>
            <Text color={colors.gray6} >
                {dayjs(createdAt).format('YYYY.MM.DD HH:mm')}
            </Text>
        </Column>
        <Text size='3xl' fontWeight='bold'>
            {t('info.orderNumber', {
                number: (displayOrderNo || `${shopOrderNo}`).padStart(4, '0'),
            })}
            {status === 'CANCELLED' && (
                <>
                    &nbsp;
                    {t('info.cancelledLabel')}
                </>
            )}
        </Text>
    </Column>;
}

const Badge = styled.div<{
    type: 'primary' | 'secondary'
}>`
    height: 18px;
    padding: 0 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ type }) => (type === 'primary'
        ? 'var(--color-primary)' : 'var(--color-gray2)')};
    color: ${({ type }) => (type === 'primary' ? 'white' : colors.gray7)};
    border-radius: 4px;
    font-size: 9px;
    line-height: 1.4;
    font-weight: 500;
`;

export default OrderInfo;
